import React, { useState, useEffect } from "react"
import { DateTime } from "luxon"

import _ from "lodash"
import { useParams } from "react-router-dom"

import api from "../../api/axiosInstance"

import { GET } from "../../config/constants"

import { Card } from "primereact/card"
import { Button } from "primereact/button"

// Data Grid
import ReactDataGrid from "@inovua/reactdatagrid-enterprise"

// Comps
import ProjectSummary from "./components/ProjectSummary"

// Loaders
import { LoaderProgressBar } from "../../components/Loaders"

// Filters
import NumberFilter from "@inovua/reactdatagrid-community/NumberFilter"
import SelectFilter from "@inovua/reactdatagrid-community/SelectFilter"

import handleStatusMessage from "../../helpers/handleStatusMessage"

import "@inovua/reactdatagrid-enterprise/index.css"

export default function ProjectDetails() {
  const { docId } = useParams()

  const [loading, serLoading] = useState(false)

  const [data, setData] = useState([])

  const [projectMetadata, setProjectMetadata] = useState({})

  const [columns, setColumns] = useState([])
  const [defaultFilterValue, setDefaultFilterValue] = useState([])

  useEffect(() => {
    const fetch = async () => {
      serLoading(true)
      try {
        const response = await api.post(`/${GET.GET_PROJECT_SUMMARY}`, {
          project_id: docId,
        })

        const handleData = _.map(response.data.data, (row) => {
          return {
            ...row,
            timestamp_updated: DateTime.fromSeconds(
              row.timestamp_updated._seconds
            ).toFormat("F"),
            bq_dataset_url: (
              <Button
                onClick={() => window.open(row.bq_dataset_url, "_blank")}
                label="Connect"
                icon="pi pi-arrow-up-right"
                size="small"
                className="p-button-sm"
              />
            ),
          }
        })
        setData(handleData)
        const handleColumns = _.map(response.data.columns, (column) => {
          if (!_.isEmpty(column.filterEditor)) {
            switch (column.filterEditor) {
              case "SelectFilter":
                column.filterEditor = SelectFilter
                return column
              case "NumberFilter":
                column.filterEditor = NumberFilter
                return column
              case "DateFilter":
                column.filterEditor = "" // not in use.
                return column
              default:
                return column
            }
          }
          return column
        })
        setColumns(handleColumns)
        setDefaultFilterValue(response.data.defaultFilterValue)

        setProjectMetadata(response.data.project_metadata)

        serLoading(false)
      } catch (error) {
        console.log(error)
      }
    }
    fetch()
  }, [])

  const handleProjectMetadata = () => {
    if (_.isEmpty(projectMetadata)) return null
    return (
      <Card title={projectMetadata.project_name}>
        <div>Alias: {projectMetadata.project_alias}</div>

        <div>
          Updated:{" "}
          {DateTime.fromSeconds(
            projectMetadata.project_datetime_updated._seconds
          ).toFormat("ff")}
        </div>

        <div style={{ marginTop: 10 }}>
          {handleStatusMessage(projectMetadata.project_status)}
        </div>
      </Card>
    )
  }

  if (loading) return <LoaderProgressBar />

  const renderRowDetails = ({ data }) => {
    return (
      <div style={{ padding: 20 }}>
        <h3>Row details:</h3>
        <table>
          <tbody>
            {Object.keys(data).map((name, i) => {
              return (
                <tr key={i}>
                  <td>{name}</td>
                  <td>{data[name]}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    )
  }

  return (
    <div>
      <h1>Dataset Management</h1>
      <ProjectSummary projectMetadata={projectMetadata} />
      <ReactDataGrid
        licenseKey={process.env.REACT_APP_RDG}
        idProperty="id"
        pagination
        defaultFilterValue={defaultFilterValue}
        columns={columns}
        style={{ minHeight: "60vh", marginTop: 15 }}
        dataSource={data}
        enableColumnAutosize
        rowExpandHeight={300}
        rowHeight={60}
        renderRowDetails={renderRowDetails}
      />
    </div>
  )
}
